import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

/* Cation: Do not change == into === in this file. It would malfunction in certain cases */

const initialState = {
    employeeAreas: [],
    employeeTerritory: null,
    isTerritoryAssigned: null,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    isDuplicateRegion: false,
    error: null
};

const regionAreaCompare = (a, b, areaProp) => {
    var nameA = a[areaProp].toUpperCase(); // ignore upper and lowercase
    var nameB = b[areaProp].toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
};

export default function employeeRegionReducer(state = initialState, action) {

    switch (action.type) {

        // ADD
        case Constants.REQUEST_ADD_EMPLOYEE_REGION:
        case Constants.REQUEST_ADD_EMPLOYEE_TERRITORY:
        case Constants.REQUEST_ADD_EMPLOYEE_LOCATION:
        case Constants.REQUEST_ADD_EMPLOYEE_ROUTE:
        case Constants.REQUEST_ADD_EMPLOYEE_DISTRIBUTORS:
        var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_EMPLOYEE_REGION:
            var newState = { ...state };
            newState.isPosting = false;
            newState.employeeAreas = [...state.employeeAreas, action.payload];
            newState.employeeAreas.sort((a, b) => regionAreaCompare(a, b, "regionName"));
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.SUCCESS_ADD_EMPLOYEE_TERRITORY:
            var newState = { ...state };
            newState.isPosting = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            var regionToAdd = newState.employeeAreas.find(a => a.id == action.regionId);
            if (regionToAdd) {
                regionToAdd["territories"].push(action.payload);
                regionToAdd["territories"].sort((a, b) => regionAreaCompare(a, b, "territoryName"));
            }
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.SUCCESS_ADD_EMPLOYEE_DISTRIBUTORS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.SUCCESS_ADD_EMPLOYEE_LOCATION:
            var newState = { ...state };
            newState.isPosting = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            var distributorToAdd = (((newState.employeeAreas.find(a => a.territories).territories || []).find(b => b.distributors)
                .distributors || []).find(c => c.id == action.distributorId) || []).locations;
            if (distributorToAdd) {
                distributorToAdd.push(action.payload);
                distributorToAdd.sort((a,b)=> regionAreaCompare(a, b, "locationName"));
            }
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.SUCCESS_ADD_EMPLOYEE_ROUTE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            newState.error = null;
            newState.isPosted = true;
            return newState;
        
        case Constants.FAILED_ADD_EMPLOYEE_REGION:
        case Constants.FAILED_ADD_EMPLOYEE_TERRITORY:
        case Constants.FAILED_ADD_EMPLOYEE_LOCATION:
        case Constants.FAILED_ADD_EMPLOYEE_ROUTE:
        case Constants.FAILED_ADD_EMPLOYEE_DISTRIBUTORS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        // GET
        case Constants.REQUEST_GET_EMPLOYEE_REGIONS:
        case Constants.REQUEST_GET_EMPLOYEE_TERRITORIES:
        case Constants.REQUEST_GET_EMPLOYEE_DISTRIBUTORS:
        case Constants.REQUEST_GET_EMPLOYEE_LOCATIONS:
        case Constants.REQUEST_GET_EMPLOYEE_ROUTES:
        case Constants.REQUEST_GET_SINGLE_EMPLOYEE_TERRITORY:
        case Constants.REQUEST_GET_ASSIGNED_TERRITORY:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEE_REGIONS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeAreas = action.payload;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEE_TERRITORIES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            var regionToAdd = newState.employeeAreas.find(a => a.id == action.regionId);
            if (regionToAdd) regionToAdd["territories"] = action.payload;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEE_DISTRIBUTORS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            var territoryToAdd = (newState.employeeAreas
                .find(a => a.territories && a.territories.find(b => b.id == action.territoryId)).territories || [])
                .find(a => a.id == action.territoryId);
            if (territoryToAdd) territoryToAdd["distributors"] = action.payload;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEE_LOCATIONS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            var distributorToAdd = (((newState.employeeAreas.find(a => a.territories).territories || []).find(b => b.distributors)
                .distributors || []).find(c => c.id == action.distributorId) || []);
            if (distributorToAdd) distributorToAdd["locations"] = action.payload;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEE_ROUTES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeAreas = cloneDeep(state.employeeAreas);
            var locationToAdd = (((newState.employeeAreas.find(a => a.territories).territories || []).find(b => b.distributors)
                .distributors || []).find(c => c.locations).locations || []).find(d=> d.id == action.locationId) || [];
            if (locationToAdd) locationToAdd["routes"] = action.payload;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_EMPLOYEE_TERRITORY:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeTerritory = action.payload;
            return newState;

        case Constants.SUCCESS_GET_ASSIGNED_TERRITORY:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.isTerritoryAssigned = action.payload;
            return newState;

        case Constants.FAILED_GET_EMPLOYEE_REGIONS:
        case Constants.FAILED_GET_EMPLOYEE_TERRITORIES:
        case Constants.FAILED_GET_EMPLOYEE_DISTRIBUTORS:
        case Constants.FAILED_GET_EMPLOYEE_LOCATIONS:
        case Constants.FAILED_GET_EMPLOYEE_ROUTES:
        case Constants.FAILED_GET_SINGLE_EMPLOYEE_TERRITORY:
        case Constants.FAILED_GET_ASSIGNED_TERRITORY:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        //RESET
        case Constants.REQUEST_CLEAR_ERROR_SUCCESS:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isTerritoryAssigned = null;
            return newState;
        case Constants.RESET_EMPLOYEE_AREA:
            var newState = {
                ...state,
                employeeAreas: [],
                employeeTerritory: null,
                isLoading: false,
                isTerritoryAssigned: null,
                isPosting: false,
                isPosted: false,
                isDuplicateRegion: false,
                error: null
            };
            return newState;

        //case Constants.REQUEST_GET_SINGLE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.isPosted = false;
        //    newState.error = null;
        //    newState.isLoading = true;
        //    newState.isPosting = false;
        //    //newState.filteredUsers = action.filteredUsers;
        //    return newState;

        //case Constants.SUCCESS_GET_SINGLE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isPosted = false;
        //    newState.error = null;
        //    newState.isLoading = false;
        //    newState.employeeRegion = action.payload;
        //    return newState;

        //case Constants.FAILED_GET_SINGLE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isPosted = false;
        //    newState.isLoading = false;
        //    newState.error = action.error;
        //    return newState;

        //case Constants.REQUEST_CHECK_DUPLICATE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isPosted = false;
        //    newState.error = null;
        //    newState.isLoading = true;
        //    return newState;

        //case Constants.SUCCESS_CHECK_DUPLICATE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isPosted = false;
        //    newState.error = null;
        //    newState.isLoading = false;
        //    newState.isDuplicateRegion = action.payload;
        //    return newState;

        //case Constants.ERROR_CHECK_DUPLICATE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isPosted = false;
        //    newState.isLoading = false;
        //    newState.error = action.error;
        //    return newState;

        //case Constants.RESET_SINGLE_EMPLOYEE_REGION:
        //    var newState = { ...state };
        //    newState.employeeRegion = null;
        //    return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/EmployeeAreaReducer.js